var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.$options.c.Avatar,{tag:"component",attrs:{"user":_vm.props.user,"message":_vm.props.message,"size":"small"}})}
var staticRenderFns = []

export { render, staticRenderFns }